<template>
  <div class="cr-payments">
    <div class="cr-container">
      <div v-if="debtLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
      <div v-if="debtError" class="cr-detail-card__message cr-message cr-message--error">{{ debtError }}</div>
      <div v-if="debtLoaded" class="cr-payments__main">
        <div class="cr-payments__title">
          Задолженность
        </div>
        <dl class="cr-payments__list">
          <div class="cr-payments__item">
            <dt class="cr-payments__term">
              Дебиторская задолженность
            </dt>
            <dd class="cr-payments__value">
              {{ debt.debt }} ₽
            </dd>
          </div>
          <div class="cr-payments__item">
            <dt class="cr-payments__term">
              В т.ч. просроченная
            </dt>
            <dd class="cr-payments__value">
                                <span class="cr-text-negative">
                                    {{ debt.over_debt }} ₽
                                </span>
            </dd>
          </div>
        </dl>
        <div v-if="debt.over_debt > 0" class="cr-message cr-message--notification">
          Пожалуйста, оплатите просроченную дебиторскую задолженность
        </div>
      </div>
      <div v-if="serverError" class="cr-detail-card__message cr-message cr-message--error" v-html="serverError"></div>
      <div class="cr-payments__section">
        <div class="cr-payments__title">
          Запросить акт сверки за период
        </div>
        <form class="cr-payments__form cr-form"  @submit.prevent="submitForm">
          <fieldset class="cr-form__fieldset">
            <div class="cr-form__item-wrapper">
              <div class="cr-form__label">
                Выберите квартал или введите другой период
                <span class="cr-form__asterisk">
                                        *
                                    </span>
              </div>
              <div class="cr-scroll-row">
                <ul class="cr-scroll-row__list">
                  <li v-for="quarter in quarters" :key="quarter.id" class="cr-scroll-row__item">
                    <div class="cr-form__field">
                      <input
                          class="cr-form__checkbox cr-form__checkbox--button-light"
                          type="radio"
                          :name="'quarter'"
                          :id="quarter.id"
                          :value="quarter.id"
                          v-model="selectedQuarter"
                          @change="selectQuarter(quarter)"
                      >
                      <label class="cr-form__label" :for="quarter.id">
                        {{ quarter.label }}
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </fieldset>
          <fieldset class="cr-form__fieldset">
            <div class="cr-form__item-wrapper cr-form__item-wrapper--col2">
              <div class="cr-form__field">
                <div class="cr-form__label">
                  Начало
                </div>
                <div class="cr-form__date-wrapper">
                  <Datepicker
                      v-model="formData.from"
                      locale="ru-RU"
                      :max-date="formData.to"
                      format="dd.MM.yyyy"
                      class="cr-form__date"
                      auto-apply
                      :enable-time-picker="false"
                      placeholder="ДД.ММ.ГГГГ"
                  >
                    <template #input-icon></template>
                  </Datepicker>
                </div>
              </div>
              <div class="cr-form__field">
                <div class="cr-form__label">
                  Конец
                </div>
                <div class="cr-form__date-wrapper">
                  <Datepicker
                      v-model="formData.to"
                      locale="ru-RU"
                      format="dd.MM.yyyy"
                      :min-date="formData.from"
                      class="cr-form__date"
                      auto-apply
                      :enable-time-picker="false"
                      placeholder="ДД.ММ.ГГГГ"
                  >
                    <template #input-icon></template>
                  </Datepicker>
                </div>
              </div>
            </div>
          </fieldset>
          <div class="cr-form__bottom">
            <button class="cr-button" type="submit" :disabled="!formData.from || !formData.to">
                                <span class="cr-button__text">
                                    Запросить акт сверки
                                </span>
            </button>
          </div>
        </form>
      </div>
      <div class="cr-payments__documents accordion">
        <div class="cr-payments__documents-wrapper accordion__item" ref="accordionItem1">
          <button  @click="toggleAccordion(1)" class="cr-payments__documents-button accordion__trigger" type="button">
            Запрошенные акты
          </button>
          <div class="cr-payments__documents-body accordion__body">
            <div v-if="reportLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
            <div v-if="reportError" class="cr-detail-card__message cr-message cr-message--error">{{ reportError }}</div>
            <div v-if="reportLoaded" class="cr-payments__documents-inner">
              <ul class="cr-payments__documents-list">
                <li v-for="item in report" class="cr-payments__documents-item">
                  <div class="cr-document-card">
                    <div class="cr-document-card__info">
                      <div class="cr-document-card__header">
                        <div class="cr-document-card__period">
                          {{ item.from }} – {{ item.to }}
                        </div>
                        <div class="cr-document-card__status" :class="'cr-document-card__status--'+item.status">
                          {{ item.status_name }}
                        </div>
                      </div>
                      <div class="cr-document-card__date">
                        <div class="cr-document-card__date-title">
                          Дата запроса
                        </div>
                        <div class="cr-document-card__date-value">
                          {{ item.date }}
                        </div>
                      </div>
                    </div>
                    <div v-if="item.file" class="cr-document-card__action">
                      <a class="cr-button cr-button--light" target="_blank" :href="item.file" download="Акт сверки.pdf">
                                                <span class="cr-button__text">
                                                    Скачать акт
                                                </span>
                      </a>
                    </div>
                    <div v-if="!item.file" class="cr-document-card__action">
                      <a class="cr-button cr-button--light" @click="getReport(item.id)" >
                                                <span class="cr-button__text">
                                                    Получить акт
                                                </span>
                      </a>
                    </div>
                  </div>
                </li>
              </ul>
              <button v-if="!this.noMoreReport" @click="showMore" class="cr-button cr-button--light js-button-more" type="button">
                                    <span class="cr-button__text">
                                        Показать еще
                                    </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="cr-modal" :class="{isOpen: successModal}" id="result1Modal">
    <div class="cr-modal__outer">
      <div class="cr-modal__inner">
        <div class="cr-modal__heading">
          <button @click="successModal=false" class="cr-modal__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
            <svg class="cr-modal__close-icon" width="30" height="30" viewBox="0 0 30 30">
              <use xlink:href="/assets/img/svg/sprite.svg#icon-cross-1"></use>
            </svg>
          </button>
          <div v-if="!successFile" class="cr-modal__title">
            Акт сверки еще не сформирован. Обратитесь к своему менеджеру.
          </div>
          <div v-if="successFile">
            Акт сверки еще сформирован.
            <a class="cr-button cr-button--light" target="_blank" :href="successFile" download="Акт сверки.pdf">
                                                <span class="cr-button__text">
                                                    Скачать акт
                                                </span>
            </a>
          </div>
        </div>
        <div class="cr-modal__bottom">
          <button @click="successModal=false" class="cr-button js-button-close" type="button">
                                <span class="cr-button__text">
                                    Закрыть
                                </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import {mapActions, mapGetters} from "vuex";
import axios from "axios";
import scrollToError from "@/mixin/scrollToError.vue";

export default {
  data: () => ({
    currentPage: 1,
    selectedQuarter: null,
    formData: {
      from: '',
      to: ''
    },
    successModal: false,
    isSubmitting: null,
    serverError: null,
    successFile: false
  }),
  mixins: [scrollToError],
  components: {
    Datepicker

  },
  created() {
    this.fetchDebt();
    this.fetchReport({page: 1});
  },
  watch: {
    'formData.from'() {
      this.clearQuarterSelection()
    },
    'formData.to'() {
      this.clearQuarterSelection()
    }
  },

  computed: {
    ...mapGetters([
      'user',
    ]),
    ...mapGetters('report', [
      'report',
      'reportLoading',
      'reportError',
      'reportLoaded',
        'noMoreReport',
        'quarters'
    ]),
    ...mapGetters('debt', [
      'debt',
      'debtLoading',
      'debtError',
      'debtLoaded'
    ]),
  },
  methods: {
    ...mapActions('report', [
      'fetchReport'
    ]),
    ...mapActions('debt', [
      'fetchDebt'
    ]),
    toggleAccordion(index, open = false) {
      // Получаем DOM элемент из массива refs
      const accordionItem = this.$refs[`accordionItem${index}`];
      const accordionBody = accordionItem.querySelector('.accordion__body');
      const isActive = accordionItem.classList.contains('is-active');

      if (isActive && !open) {
        // Закрываем аккордеон
        const height = accordionBody.scrollHeight;
        accordionBody.style.height = `${height}px`;

        // Форсируем reflow
        accordionBody.offsetHeight;

        accordionBody.style.height = '0px';
        accordionItem.classList.remove('is-active');
      } else {
        // Открываем аккордеон
        accordionItem.classList.add('is-active');
        const height = accordionBody.scrollHeight;
        accordionBody.style.height = `${height}px`;

        // После завершения анимации устанавливаем height: auto
        setTimeout(() => {
          accordionBody.style.height = 'auto';
        }, 300);
      }
    },
    async submitForm() {

      this.isSubmitting = true;
      this.serverError = null;
      this.successFile = false;

      const formDataToSubmit = {
        ...this.formData,
      };

      let url = '/api/finreport/';
      try {
        const response = await axios.post(url, formDataToSubmit,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
        if (response.data.status == 'error') {
          this.serverError= '';
          for (let i in response.data.errors) {
            console.log(typeof response.data.errors[i].code)
            if (typeof response.data.errors[i].code == 'number') {
              this.serverError = 'Ошибка сервера.';
              break;
            }
            else
              this.serverError += response.data.errors[i].message+"<br>";
          }
          throw new Error(this.serverError);
        }
        if (response.data.data && response.data.file) {
          this.successFile = true;
        }

          this.successModal = true;
        this.fetchReport({page: 1, first:false});

        this.toggleAccordion(1, true);


      } catch (error) {
        this.serverError = error;
        this.scrollToFirstError();
      } finally {
        this.isSubmitting = false;
      }


    },
    async getReport(id) {

      this.isSubmitting = true;
      this.serverError = null;
      this.successFile = false;

      const formDataToSubmit = {
        ...this.formData,
      };

      let url = '/api/finreport/'+id+'/';
      try {
        const response = await axios.get(url);
        if (response.data.status == 'error') {
          this.serverError= '';
          for (let i in response.data.errors) {
            console.log(typeof response.data.errors[i].code)
            if (typeof response.data.errors[i].code == 'number') {
              this.serverError = 'Ошибка сервера.';
              break;
            }
            else
              this.serverError += response.data.errors[i].message+"<br>";
          }
          throw new Error(this.serverError);
        }
        if (response.data.data && response.data.file) {
          this.successFile = true;
        }

        this.successModal = true;
       // this.fetchReport({page: 1, first:false});

      //  this.toggleAccordion(1, true);


      } catch (error) {
        this.serverError = error;
        this.scrollToFirstError();
      } finally {
        this.isSubmitting = false;
      }


    },
    selectQuarter(quarter) {
      this.formData.from = new Date(quarter.start)
      this.formData.to = new Date(quarter.end)
    },
    clearQuarterSelection() {
      // Проверяем, было ли изменение ручным
      const isManualChange = !this.quarters.some(q =>
          this.isSameDate(new Date(q.start), this.formData.from) &&
          this.isSameDate(new Date(q.end), this.formData.to)
      )

      if (isManualChange) {
        this.selectedQuarter = null
      }
    },
    isSameDate(date1, date2) {
      if (!date1 || !date2) return false
      return date1.toISOString().split('T')[0] === new Date(date2).toISOString().split('T')[0]
    },
    showMore() {
      if (!this.noMoreReport) {
        this.currentPage++;
        this.fetchReport({page: this.currentPage});
      }
    }


  }
}
</script>

<style>
.dp__input {border: 0; background: transparent; padding: 0; height: 46px; line-height: 46px;}
</style>